import React from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import ModalDialog from "@mui/joy/ModalDialog";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import Box from "@mui/joy/Box";
import Card from "@mui/joy/Card";
import Grid from "@mui/joy/Grid";
import AspectRatio from "@mui/joy/AspectRatio";
import CardOverflow from "@mui/joy/CardOverflow";

export default function ModalParticipante({ estado, cerrar, participantes }) {
  let linkimagen = process.env.REACT_APP_DOSPACES;

  const calcularEdad = (fechaNacimiento) => {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    const edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      return edad - 1;
    }
    return edad;
  };

  let aventurero = (foto, nombre, edad, pais, biografia) => {
    return (
      <Card sx={{ padding: 0 }} variant="soft">
        <Box
          sx={{
            display: "flex",
            alignContent: "center",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CardOverflow>
            <AspectRatio
              ratio="1"
              sx={{
                width: 90,
                borderTopLeftRadius: "8px",
                borderBottomLeftRadius: "8px",
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
                height: "auto",
              }}
            >
              <img
                src={`${linkimagen}/uploads/${foto}`}
                srcSet={`${linkimagen}/uploads/${foto}`}
                loading="lazy"
                alt={`${nombre}`}
              />
            </AspectRatio>
          </CardOverflow>
          <Grid container spacing={2} sx={{ width: "100%" }}>
            <Grid
              xs={11}
              sx={{
                display: "flex",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "grid" }}>
                <Typography level="title-sm">
                  {nombre}, {calcularEdad(edad)} Años
                </Typography>
                <Typography level="body-xs">{pais}</Typography>
                <Typography level="body-xs">{biografia}</Typography>
              </Box>
            </Grid>
            <Grid
              xs={1}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            ></Grid>
          </Grid>
        </Box>
      </Card>
    );
  };

  return (
    <Modal open={estado} onClose={cerrar}>
      <ModalDialog sx={{ width: "auto" }}>
        <ModalClose onClick={cerrar} />
        <Box
          sx={{
            overflow: "auto",
            maxHeight: "70vh",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {participantes.map((x) => {
            return aventurero(
              x.foto_de_perfil,
              x.nombre,
              x.fecha_de_nacimiento,
              x.pais,
              x.descripcion_perfil
            );
          })}
        </Box>
      </ModalDialog>
    </Modal>
  );
}
